import { formatStripeMinorAmount } from "@/features/stripe/utils/stripeMoney";
import { formatBusinessDate } from "@/shared/utils/formatters";
import type { SubscriptionOffer, SubscriptionUsage } from "../types/subscriptionTypes";

// Plan periods and usage limits reset in UTC.
export const formatPlanDate = (date: Date, withYear = false) =>
  formatBusinessDate(date, "UTC", withYear ? { month: "short", day: "numeric", year: "numeric" } : { month: "short", day: "numeric" });

export const formatOfferPrice = (offer: SubscriptionOffer) =>
  `${formatStripeMinorAmount(offer.price.amountMinor, offer.price.currency.toUpperCase())} / ${offer.price.interval}`;

export const isUsageLimitReached = (usage: SubscriptionUsage | undefined) => !!usage && usage.limit > 0 && usage.used >= usage.limit;

export const formatUsageLabel = (usage: SubscriptionUsage) =>
  `SMS this month: ${usage.used} / ${usage.limit} · resets ${formatPlanDate(usage.resetsAt)}`;
